import { render, staticRenderFns } from "./ManageProgramRatings.vue?vue&type=template&id=e93e0c2e&scoped=true&"
import script from "./ManageProgramRatings.vue?vue&type=script&lang=js&"
export * from "./ManageProgramRatings.vue?vue&type=script&lang=js&"
import style0 from "./ManageProgramRatings.vue?vue&type=style&index=0&id=e93e0c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93e0c2e",
  null
  
)

export default component.exports